
module.exports = function()
{
    this.title = "";
    this.message = "";
    this.onConfirm = null;
    this.onCancel = null;
}